import {
  Store,
  get,
} from 'idb-keyval';

export const name = '$stStations';
export default function $stStations() {
  'ngInject';

  // Constants
  const idbStore = new Store('printos', 'hmacs');

  // Variables

  // Service
  let service = {
    hasKey,
  };
  return service;

  //////////////
  // Service

  function hasKey() {
    return get('trustedStation', idbStore).then(hmac => {
      return hmac !== undefined;
    });
  }
}



// WEBPACK FOOTER //
// ./components/sign-in/stations.service.js